<template>
  <el-table :data="data" style="width: 100%;" :row-class-name="tableRowClassName" height="calc(100% - 140px)">
    <el-table-column label="序号" type="index" width="100">
    </el-table-column>
    <el-table-column prop="UserCode" label="客户代码">
    </el-table-column>
    <el-table-column prop="UserName" label="客户名称">
    </el-table-column>
    <el-table-column prop="ContractNo" label="合约代码" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="ContractName" label="合约名称" :show-overflow-tooltip="true">
    </el-table-column>
    <!-- <el-table-column prop="Direction" label="方向">
      <template slot-scope="scope">
        <span>{{scope.row.Direction | GetDirection}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="PositionEffect" label="开平">
      <template slot-scope="scope">
        <span>{{scope.row.PositionEffect | PositionEffect}}</span>
      </template>
    </el-table-column> -->
    <el-table-column prop="HoldBuyVolume" label="持买量">
    </el-table-column>
    <el-table-column prop="HoldBuyPrice" label="持买均价">
    </el-table-column>
    <el-table-column prop="HoldSaleVolume" label="持卖量">
    </el-table-column>
    <el-table-column prop="HoldSalePrice" label="持卖均价">
      <!-- <template slot-scope="scope">
        <span>{{scope.row.OrderState | GetDelegateOrderStateType}}</span>
      </template> -->
    </el-table-column>
    <el-table-column prop="LastPrice" label="最新价">
    </el-table-column>
    <el-table-column prop="Margin" label="保证金">
    </el-table-column>
    <el-table-column prop="PositionProfit" label="持仓盈亏">
    </el-table-column>
    <el-table-column prop="CurrencyNo" label="货币代码" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="ExchangeNo" label="交易所编号" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="ExchangeName" label="交易所名称" :show-overflow-tooltip="true">
    </el-table-column>
    <!-- 查看明细弹窗 -->
  </el-table>
</template>

<script>
import EnumConfig from "../../../assets/js/EnumConfig.js";
export default {
  // 委托表格
  name: "mycapitalT",
  data() {
    return {
      dialogVisible: false,
      obj: {}
    };
  },
  props: ["data"],
  filters: {
    GetDelegateOrderStateType(type) {
      return EnumConfig.GetDelegateOrderStateType(type);
    },
    GetDirection(type) {
      return EnumConfig.GetDirection(type);
    },
    PositionEffect(type) {
      return EnumConfig.PositionEffect(type);
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleClick(row) {
      this.dialogVisible = true;
      this.obj = row;
    }
  }
};
</script>

<style scoped>
</style>
 


// WEBPACK FOOTER //
// src/components/selects/position/positionDetailT.vue